import styled from "styled-components";

// Theme
import colors from "../../theme/colors";

export const Svg = styled.svg`
  fill: ${colors.primary};
`;
